import VacancyCollaborators from './VacancyCollaborators.page';

export default VacancyCollaborators;